const dataContactUs = {
  heroTitle: 'Contact',
  info: {
    subheading: 'Luați legătura cu noi.',
    workingHoursTitle: 'Ore de lucru',
    time1: 'Luni - Joi de la 8:00 - 20:00',
    time2: 'Vineri - Duminică de la 8:00 - 21:00',
    footnote: 'Servim cu mândrie clienții din Drochia, precum și din zonele apropiate.'
  }
};

export default dataContactUs;
